import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/Menu.css';
import { UserContext } from '../contexts/UserContext';

export default function Menu() {
  const [utilOpen, setUtilOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);

  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const toggleUtil = () => setUtilOpen(!utilOpen);
  const toggleUser = () => setUserOpen(!userOpen);

  const handleLogout = () => {
    setUser(null);
    navigate('/');
  };

  return (
    <nav className="menu-bar">
      <div className="menu-left">
        <Link to="/home" className="menu-item home-button">
          <img src="/images/home.png" alt="Home" className="home-icon" />
        </Link>

        <Link to="/tablero" className="menu-item">Tablero</Link>
        <Link to="/datos" className="menu-item">Datos Recolectados</Link>
        <Link to="/mi-usuario" className="menu-item">Mi usuario</Link>

        <div className="menu-item submenu-container">
          <button onClick={toggleUtil} className="submenu-button">
            Util ▼
          </button>
          {utilOpen && (
            <div className="submenu">
              <Link to="/util/obtener" className="submenu-item">Obtener datos</Link>
              <Link to="/util/actualizar" className="submenu-item">Actualizar base de datos</Link>
            </div>
          )}
        </div>
      </div>

      <div className="menu-right">
        <div className="menu-item submenu-container">
          <button onClick={toggleUser} className="submenu-button">
            {user ? user.email : 'consulta@simsan.org.gt'}
          </button>
          {userOpen && (
            <div className="submenu">
              <button className="submenu-item" onClick={handleLogout}>Desconectarse</button>
              <button className="submenu-item">Cambiar contrasenia</button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
